export enum BrandCardSource {
  DISCOVER_BRAND = "discoverBrands",
  CAMPAIGN_BRAND = "campaignBrands",
  MORE_INFO_BRAND = "moreInfoBrand",
  ONBOARDING_BRAND = "onboardingBrands",
  SIMILAR_BRANDS = "similarBrands",
  THREAD_BRAND = "threadBrand",
}
